import { createFileRoute } from '@tanstack/react-router';

import { Security } from '@/features/settings';

export const Route = createFileRoute('/_auth/_org/settings/security')({
  component: Security,
});
